import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import {Button, Card, CardBody, Col, FormFeedback, FormGroup, Input, Label, Row} from "reactstrap";
import {Field, Form, Formik} from "formik";
import axios from "axios";
import _ from "lodash";

import authentication from "../../redux/authentication";
import FormListener from "../../components/FormListener";
import {LayoutFullScreen} from "../../layouts";

const Login = () => {
	const [error, setError] = React.useState({});
	const history = useHistory();
	const dispatch = useDispatch();
	const {user} = useSelector(({authentication}) => authentication);

	const handleFormSubmit = React.useCallback((values, {setSubmitting}) => {
		setError({});

		axios.post('/api/admin/auth/login', values)
			.then(({data}) => {
				dispatch(authentication.actions.login(data));
			})
			.catch(({data}) => {
				setError(data);
			})
			.finally(() => {
				setSubmitting(false);
			});
	}, []);
	const handleFormChange = React.useCallback(() => {
		setError({});
	}, []);

	React.useEffect(() => {
		if (user) {
			history.push('/admin');
		}
	}, [user]);

	return (
		<Row className="h-100">
			<Col xs={12} md={6} lg={4} className="m-auto">
				<img src="/images/horus.png" className="w-100 mb-5"/>

				<Card className="auth-card">
					<CardBody>
						{!_.isEmpty(error) && (
							<div className={'text-danger text-center mb-4'}>Si è verificato un errore: {error.message}</div>
						)}

						<Formik
							initialValues={{
								email: '',
								password: '',
							}}
							validateOnBlur={false}
							// TODO validation
							// validationSchema={Yup.object().shape({
							// 	email: Yup.string()
							// 	// .email('Email is not valid')
							// 		.required('Email is required'),
							// 	password: Yup.string()
							// 		.required('Password is required'),
							// })}
							onSubmit={handleFormSubmit}
						>
							{({errors, touched, isSubmitting, dirty}) => (
								<Form>
									<FormListener onChange={handleFormChange}/>

									<FormGroup className="has-float-label">
										<Label>Username</Label>
										<Input
											tag={Field}
											type={'text'}
											className={'form-control'}
											name={'email'}
											invalid={errors.email && touched.email}
											autoFocus={true}
										/>
										<FormFeedback>{errors.email}</FormFeedback>
									</FormGroup>

									<FormGroup className="has-float-label">
										<Label>Password</Label>
										<Input
											tag={Field}
											type={'password'}
											className={'form-control'}
											name={'password'}
											invalid={errors.password && touched.password}
										/>
										<FormFeedback>{errors.password}</FormFeedback>
									</FormGroup>

									<div className="text-center">
										<Button
											type="submit"
											color="primary"
											size="lg"
											disabled={!_.values(errors).every(_.isEmpty) || !dirty}
										>
											Accedi
										</Button>
									</div>
								</Form>
							)}
						</Formik>
					</CardBody>
				</Card>
			</Col>
		</Row>
	);
};

export default () => (
	<LayoutFullScreen>
		<Login/>
	</LayoutFullScreen>
);
